import { TRole } from '@verdocs/js-sdk';

export const getRoleLevel = (roleName: TRole) => {
  switch (roleName) {
    case 'owner':
      return 4;
    case 'admin':
      return 3;
    case 'member':
    case 'basic_user':
      return 2;
    case 'contact':
      return 0;
    default:
      return 0;
  }
};

// basic_user is a deprecated name for member
export const getHighestRole = (roles: TRole[]): TRole | undefined =>
  roles.find(r => r === 'owner') ||
  roles.find(r => r === 'admin') ||
  (roles.some(r => r === 'member' || r === 'basic_user') ? 'member' : undefined) ||
  roles.find(r => r === 'contact') ||
  roles[0];

export const RoleOptions: { label: string; value: TRole }[] = [
  { label: 'Owner', value: 'owner' },
  { label: 'Admin', value: 'admin' },
  { label: 'Member', value: 'member' },
  { label: 'Contact', value: 'contact' },
];
